import { Component, EventEmitter, Output } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
    selector: "welcome",
    templateUrl: "./welcome.component.html",
    styleUrls: ["./welcome.component.scss"]
})
export class WelcomeComponent  {
    constructor(
    ) {}

    emailstrings = "";

    @Output() isWelcomeScreen: EventEmitter<boolean> = new EventEmitter<boolean>();

    

    scrollToMfaSetup = () => {
        document.getElementsByClassName("welcome-page-2")[0].scrollIntoView({  behavior: 'smooth' });
    };

    scrollToSteps = step => {
        switch (step) {
            case 1:
                document.getElementById("step1").scrollIntoView({  behavior: 'smooth' });
                break;
            case 2:
                document.getElementById("step2").scrollIntoView({  behavior: 'smooth' });
                break;
            case 3:
                document.getElementById("step3").scrollIntoView({ behavior: 'smooth' });
                break;
            case 4:
                document.getElementById("step4").scrollIntoView({ behavior: 'smooth' });
                break;
            case 5:
                document.getElementById("step5").scrollIntoView({ behavior: 'smooth' });
                break;
        }
    };

    login = () => {
        this.isWelcomeScreen.emit(true);
    };

    helpEmail() {
        this.emailstrings = "mailto:" + environment.supportEmail;
    }
}
